import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { Row, Form, Col, Button } from "react-bootstrap";
import { useFieldArray, useForm } from "react-hook-form";
import {
  InputControl,
  InputValidationConstants,
  SubmitButtonContent,
  TextAreaControl,
  SelectControl,
  TinymceControl,
  createOptionsFromEnum,
  DateTimeControl,
  NumberControl,
  CheckboxControl,
} from "wup-module1-base";
import { RoutePathConstants, QuestionTypeEnum } from "../../../../Constants";
import "../../../DragAndDrop.css";
import RelatedQuestions from "./RelatedQuestions";
import { Modal as BootstrapModal } from "react-bootstrap";

function QuestionForm({
  onSubmit,
  model = null,
  isEdit = false,
  isSubmitting = false,
}) {
  const navigate = useNavigate();
  const {
    register,
    trigger,
    handleSubmit,
    reset,
    setValue,
    getValues,
    watch,
    control,
    formState: { errors, isValid },
  } = useForm({
    mode: "all",
  });
  const { append, update, remove, move, fields } = useFieldArray({
    control,
    name: "relatedQuestions",
  });
  const [content, setContent] = useState(model?.content ?? "");
  const editorRef = useRef(null);
  const answerType = watch("answer.type");
  const answerMin = watch("answer.minValue");
  const answerMax = watch("answer.maxValue");

  const handleContentChange = (html) => {
    setContent(html);
    setValue("content", html);
  };

  useEffect(() => {
    if (model !== null) {
      reset(model);
    }
  }, [model]);

  useEffect(
    () => {
      trigger();
    },
    [trigger, fields],
    answerMin,
    answerMax
  );

  const submitForm = (question) => {
    // console.log(question);
    const modifiedData = getRequestData(question);
    onSubmit(modifiedData);
  };

  const getRequestData = (question) => {
    return {
      ...question,
      relatedQuestions: getQuestionsWithUpdatedOrder(question),
    };
  };

  const getQuestionsWithUpdatedOrder = (question) => {
    return question.relatedQuestions.map((obj, index) => {
      return { ...obj, order: index + 1 };
    });
  };

  // useEffect(() => {
  //   document.addEventListener("focusin", function (e) {
  //     console.log("nowy3");
  //     e.stopImmediatePropagation();
  //     e.stopPropagation();
  //     e.preventDefault();

  //   });
  //   document.addEventListener("click", function (e) {
  //     console.log("nowy4");
  //     e.stopImmediatePropagation();
  //     e.stopPropagation();
  //     e.preventDefault();
  //   });
  // }, []);

  return (
    <Form onSubmit={handleSubmit(submitForm)}>
      <Row>
        <Col md={6}>
          <InputControl
            id={"name"}
            label={"Nazwa"}
            readOnly={false}
            refs={{
              ...register("name", {
                required: InputValidationConstants.required,
                maxLength: {
                  value: 100,
                  message: InputValidationConstants.maxLength.replace(
                    "{placeholder}",
                    100
                  ),
                },
              }),
            }}
            errors={errors}
          />
        </Col>
        <Col md={6}>
          <SelectControl
            id={"type"}
            label={"Typ"}
            readOnly={false}
            options={createOptionsFromEnum(QuestionTypeEnum, false)}
            refs={{
              ...register("type", {
                required: InputValidationConstants.required,
              }),
            }}
            errors={errors}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <TextAreaControl
            id={"description"}
            label={"Opis"}
            readOnly={false}
            rows={3}
            refs={{
              ...register("description", {
                //required: InputValidationConstants.required,
                maxLength: {
                  value: 512,
                  message: InputValidationConstants.maxLength.replace(
                    "{placeholder}",
                    512
                  ),
                },
              }),
            }}
            errors={errors}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12} sm={12}>
          <TinymceControl
            id="content"
            label="Treść"
            htmlContent={content}
            rows={4}
            onChange={handleContentChange}
          />
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <SelectControl
            id={"answer.type"}
            label={"Typ odpowiedzi"}
            readOnly={false}
            options={createOptionsFromEnum(QuestionTypeEnum, false)}
            refs={{
              ...register("answer.type", {
                required: InputValidationConstants.required,
              }),
            }}
            errors={errors}
          />
        </Col>
        {answerType && answerType == QuestionTypeEnum.Date.value && (
          <>
            <Col md={3}>
              <DateTimeControl
                id={"answer.minValue"}
                label={"Data od"}
                required={true}
                type="date"
                max={getValues("answer.maxValue")}
                refs={{
                  ...register("answer.minValue", {}),
                }}
                errors={errors}
              />
            </Col>
            <Col md={3}>
              <DateTimeControl
                id={"answer.maxValue"}
                label={"Data do"}
                required={true}
                type="date"
                min={getValues("answer.minValue")}
                refs={{
                  ...register("answer.maxValue", {
                    min: {
                      value: getValues("answer.minValue"),
                      message: 'Data nie może być wcześniejsza niż "Data od"',
                    },
                  }),
                }}
                errors={errors}
              />
            </Col>
          </>
        )}
        {answerType && answerType == QuestionTypeEnum.Number.value && (
          <>
            <Col md={3}>
              <NumberControl
                id={"answer.minValue"}
                label={"Liczba od"}
                max={getValues("answer.maxValue")}
                refs={{
                  ...register("answer.minValue", {}),
                }}
                errors={errors}
              />
            </Col>
            <Col md={3}>
              <NumberControl
                id={"answer.maxValue"}
                label={"Liczba do"}
                min={getValues("answer.minValue")}
                refs={{
                  ...register("answer.maxValue", {
                    min: {
                      value: getValues("answer.minValue"),
                      message: 'Liczba nie może być mniejsza niż "Liczba od"',
                    },
                  }),
                }}
                errors={errors}
              />
            </Col>
          </>
        )}
        {answerType && answerType == QuestionTypeEnum.Text.value && (
          <>
            <Col md={3}>
              <NumberControl
                id={"answer.minValue"}
                label={"Minimalna długość"}
                min={1}
                max={getValues("answer.maxValue")}
                refs={{
                  ...register("answer.minValue", {}),
                }}
                errors={errors}
              />
            </Col>
            <Col md={3}>
              <NumberControl
                id={"answer.maxValue"}
                label={"Maksymalna długość"}
                min={getValues("answer.minValue")}
                refs={{
                  ...register("answer.maxValue", {
                    min: {
                      value: getValues("answer.minValue"),
                      message: "Liczba nie może być mniejsza niż min. dł.",
                    },
                  }),
                }}
                errors={errors}
              />
            </Col>
            <Col md={3}>
              <NumberControl
                id={"answer.rowNr"}
                label={"Ilość wierszy"}
                min={1}
                refs={{
                  ...register("answer.rowNr", {}),
                }}
                errors={errors}
              />
            </Col>
          </>
        )}
        {answerType && answerType == QuestionTypeEnum.OptionList.value && (
          <>
            <Col md={3}>
              <NumberControl
                id={"answer.maxValue"}
                label={"Maksymalna liczba zaznaczonych"}
                min={getValues("answer.minValue")}
                refs={{
                  ...register("answer.maxValue", {}),
                }}
                errors={errors}
              />
            </Col>
            <Col md={3}>
              <NumberControl
                id={"answer.rowNr"}
                label={"Ilość wierszy"}
                min={1}
                refs={{
                  ...register("answer.rowNr", {}),
                }}
                errors={errors}
              />
            </Col>
          </>
        )}
      </Row>
      <CheckboxControl
        id={"answer.isRequired"}
        label={"Czy odpowiedź jest wymagana ?"}
        refs={{
          ...register("answer.isRequired"),
        }}
        errors={errors}
      />
      <Row>
        <Col md={12}>
          <RelatedQuestions
            register={register}
            fields={fields}
            move={move}
            remove={remove}
            append={append}
            update={update}
            getValues={getValues}
            errors={errors}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Button
            type="submit"
            variant="primary"
            disabled={!isValid || isSubmitting}
          >
            <SubmitButtonContent
              isSubmitting={isSubmitting}
              condition={isEdit}
            />
          </Button>
          <Button
            className="mx-2"
            type="button"
            variant="secondary"
            onClick={() => navigate(`/${RoutePathConstants.Question}`)}
          >
            Powrót
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default QuestionForm;
